/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantSecurityLevelCreateRequest
 */
export interface TenantSecurityLevelCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelCreateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSecurityLevelCreateRequest
     */
    displayName: string;
    /**
     * 
     * @type {number}
     * @memberof TenantSecurityLevelCreateRequest
     */
    levelValue: number;
}

/**
 * Check if a given object implements the TenantSecurityLevelCreateRequest interface.
 */
export function instanceOfTenantSecurityLevelCreateRequest(value: object): value is TenantSecurityLevelCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    if (!('levelValue' in value) || value['levelValue'] === undefined) return false;
    return true;
}

export function TenantSecurityLevelCreateRequestFromJSON(json: any): TenantSecurityLevelCreateRequest {
    return TenantSecurityLevelCreateRequestFromJSONTyped(json, false);
}

export function TenantSecurityLevelCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSecurityLevelCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'displayName': json['displayName'],
        'levelValue': json['levelValue'],
    };
}

export function TenantSecurityLevelCreateRequestToJSON(json: any): TenantSecurityLevelCreateRequest {
    return TenantSecurityLevelCreateRequestToJSONTyped(json, false);
}

export function TenantSecurityLevelCreateRequestToJSONTyped(value?: TenantSecurityLevelCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'displayName': value['displayName'],
        'levelValue': value['levelValue'],
    };
}

